import { Skeleton } from 'components';

const ProductShowSkeleton = () => {
  return (
    <div className="main-container mt-20">
      <Skeleton classNames="w-full h-48 rounded-3xl lg:h-initial lg:aspect-[3/1] xl:max-h-[35rem]" />

      <div className="mt-12 lg:grid lg:grid-cols-12 lg:gap-x-12">
        <div className="lg:col-span-8 2xl:col-span-9">
          {Array.from({ length: 8 }, (_, index) => (
            <div key={`product-skeleton-${index}`} className="mb-10 flex flex-col gap-3">
              <Skeleton classNames="w-full h-8" />
              <Skeleton classNames="w-full h-8" />
              <Skeleton classNames="w-3/4 h-8" />
            </div>
          ))}
        </div>

        <div className="hidden lg:block lg:col-span-4 2xl:col-span-3">
          <Skeleton classNames="h-80 w-full rounded-3xl" />
        </div>
      </div>
    </div>
  );
};

export default ProductShowSkeleton;
